import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://mhixfakpafenionfrpto.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

// Fail-soft : sur un environnement mal configuré (ex. preview Vercel sans
// VITE_SUPABASE_ANON_KEY), createClient lève « supabaseKey is required. » à
// l'évaluation du module. Comme cette erreur survient AVANT tout render React,
// l'ErrorBoundary ne peut pas l'attraper → page blanche totale. On détecte donc
// la config manquante ici et on expose un flag, sans appeler createClient avec
// une clé vide. main.jsx s'en sert pour afficher un écran d'erreur lisible.
// Quand la config est présente (prod/preview correctement configurés), le
// comportement est strictement identique à avant.
export const supabaseConfigError = !supabaseUrl || !supabaseAnonKey
  ? 'Configuration manquante : VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY absentes de cet environnement.'
  : null

export const supabase = supabaseConfigError
  ? null
  : createClient(supabaseUrl, supabaseAnonKey)
// Deploy trigger: 1775065302

// Inject auth token into Realtime WebSocket — covers page reload with existing session
if (supabase) {
  supabase.auth.getSession().then(({ data: { session } }) => {
    if (session?.access_token) supabase.realtime.setAuth(session.access_token);
  });

  // Keep Realtime token in sync on login, logout, and token refresh
  supabase.auth.onAuthStateChange((_event, session) => {
    supabase.realtime.setAuth(session?.access_token ?? null);
  });
}
